import React from 'react';

import NamedOutcomeRate from '../rates/NamedOutcomeRate.jsx';

const NamedOutcome = ({section, sportId, gridLocalization, outcome, match}) => {
    const type = outcome.get('type');

    const outcomeObject = {
        type,
        condition: outcome.get('condition')
    };

    const matchObject = {
        homeTeam: match.get('firstTeam'),
        awayTeam: match.get('secondTeam')
    };

    const outcomeName = gridLocalization.getOutcomeName(sportId, outcomeObject, matchObject);

    const outcomeRates = [];

    outcome.get('rates')
        .entrySeq()
        .sortBy((r) => r[0])
        .forEach((r) => {
            outcomeRates.push(r[1]);
        });

    const isBlocked = outcome.get('isBlocked');

    const cls = 'out' + (isBlocked ? ' closed' : '');

    const props = {
        section,
        gridLocalization
    };

    return (<span className={cls}>
                    {outcomeName}
            {outcomeRates.map((r) => <NamedOutcomeRate key={r} id={r} {...props} />)}
                </span>
    );
};

NamedOutcome.propTypes = {
    section: React.PropTypes.string.isRequired,
    sportId: React.PropTypes.number.isRequired,
    gridLocalization: React.PropTypes.object.isRequired,
    outcome: React.PropTypes.object.isRequired,
    match: React.PropTypes.object.isRequired
};

export default NamedOutcome;



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/outcomes/NamedOutcome.jsx